import React from "react"
import { ActivityIndicator } from "react-native"
import { Center } from "@/components/standard/BFLayout"
import { Body } from "@/components/standard/BFText"

export const LoadingState: React.FC = () => {
  return (
    <Center className="flex-1 p-5">
      <ActivityIndicator size="large" color="#286588" />
      <Body className="text-center text-midnight-blue mt-4">
        Loading events...
      </Body>
    </Center>
  )
}
